import type { SchemaConditions } from 'cpool-schemas';
import type { UseTranslationResponse } from 'react-i18next';

import { currencyFormat } from '~/lib/i18n';

export const createDataSnippetsString = (
    conditionDataSnippets: SchemaConditions['dataSnippets'],
    hasSecondApplicant: boolean,
    t: UseTranslationResponse<'de', undefined>['t'], // maybe we need to change this to a more generic type, but this allows to check the translation path
) => {
    const applicantDataSnippets: { applicant1: Array<string>; applicant2: Array<string> } = {
        applicant1: [],
        applicant2: [],
    };
    if (conditionDataSnippets?.applicant1?.salary) {
        const { salary, salaryMode } = conditionDataSnippets.applicant1;
        const translatedMode = t(
            `BANK_CREDIT_REQUEST.DATA_SHARING.HEADER_NOTIFICATIONS.SALARY_CALCULATION.${salaryMode}`,
        );
        applicantDataSnippets.applicant1.push(
            t('BANK_CREDIT_REQUEST.DATA_SHARING.HEADER_NOTIFICATIONS.SALARY', {
                amount: currencyFormat(salary),
                mode: translatedMode,
            }),
        );
    }
    if (conditionDataSnippets?.applicant1?.excludeApplicant)
        applicantDataSnippets.applicant1.push(
            t('BANK_CREDIT_REQUEST.DATA_SHARING.HEADER_NOTIFICATIONS.EXCLUDE_APPLICANT'),
        );
    if (conditionDataSnippets?.applicant1?.rentFree)
        applicantDataSnippets.applicant1.push(t('BANK_CREDIT_REQUEST.DATA_SHARING.HEADER_NOTIFICATIONS.RENT_FREE'));
    if (conditionDataSnippets?.applicant1?.withoutMaintenanceIncome)
        applicantDataSnippets.applicant1.push(
            t('BANK_CREDIT_REQUEST.DATA_SHARING.HEADER_NOTIFICATIONS.WITHOUT_MAINTENANCE_INCOME'),
        );
    if (conditionDataSnippets?.applicant1?.withoutRentIncome)
        applicantDataSnippets.applicant1.push(
            t('BANK_CREDIT_REQUEST.DATA_SHARING.HEADER_NOTIFICATIONS.WITHOUT_RENT_INCOME'),
        );
    if (conditionDataSnippets?.applicant1?.withoutSidejob)
        applicantDataSnippets.applicant1.push(
            t('BANK_CREDIT_REQUEST.DATA_SHARING.HEADER_NOTIFICATIONS.WITHOUT_SIDE_JOB'),
        );
    if (conditionDataSnippets?.applicant1?.withoutOtherIncome)
        applicantDataSnippets.applicant1.push(
            t('BANK_CREDIT_REQUEST.DATA_SHARING.HEADER_NOTIFICATIONS.WITHOUT_OTHER_INCOME'),
        );

    const firstApplicantString = `${
        applicantDataSnippets.applicant1.length > 0 ? applicantDataSnippets.applicant1.join(', ') : '-'
    } (${t('BANK_CREDIT_REQUEST.HISTORY.SECTION_HEADER.FIRST_APPLICANT')})`;

    if (!hasSecondApplicant) return firstApplicantString;

    if (conditionDataSnippets?.applicant2?.salary) {
        const { salary, salaryMode } = conditionDataSnippets.applicant2;
        const translatedMode = t(
            `BANK_CREDIT_REQUEST.DATA_SHARING.HEADER_NOTIFICATIONS.SALARY_CALCULATION.${salaryMode}`,
        );
        applicantDataSnippets.applicant2.push(
            t('BANK_CREDIT_REQUEST.DATA_SHARING.HEADER_NOTIFICATIONS.SALARY', {
                amount: currencyFormat(salary),
                mode: translatedMode,
            }),
        );
    }
    if (conditionDataSnippets?.applicant2?.excludeApplicant)
        applicantDataSnippets.applicant2.push(
            t('BANK_CREDIT_REQUEST.DATA_SHARING.HEADER_NOTIFICATIONS.EXCLUDE_APPLICANT'),
        );
    if (conditionDataSnippets?.applicant2?.rentFree)
        applicantDataSnippets.applicant2.push(t('BANK_CREDIT_REQUEST.DATA_SHARING.HEADER_NOTIFICATIONS.RENT_FREE'));
    if (conditionDataSnippets?.applicant2?.withoutMaintenanceIncome)
        applicantDataSnippets.applicant2.push(
            t('BANK_CREDIT_REQUEST.DATA_SHARING.HEADER_NOTIFICATIONS.WITHOUT_MAINTENANCE_INCOME'),
        );
    if (conditionDataSnippets?.applicant2?.withoutRentIncome)
        applicantDataSnippets.applicant2.push(
            t('BANK_CREDIT_REQUEST.DATA_SHARING.HEADER_NOTIFICATIONS.WITHOUT_RENT_INCOME'),
        );
    if (conditionDataSnippets?.applicant2?.withoutSidejob)
        applicantDataSnippets.applicant2.push(
            t('BANK_CREDIT_REQUEST.DATA_SHARING.HEADER_NOTIFICATIONS.WITHOUT_SIDE_JOB'),
        );
    if (conditionDataSnippets?.applicant2?.withoutOtherIncome)
        applicantDataSnippets.applicant2.push(
            t('BANK_CREDIT_REQUEST.DATA_SHARING.HEADER_NOTIFICATIONS.WITHOUT_OTHER_INCOME'),
        );

    return `${firstApplicantString} / ${
        applicantDataSnippets.applicant2.length > 0 ? applicantDataSnippets.applicant2.join(', ') : '-'
    } (${t('BANK_CREDIT_REQUEST.HISTORY.SECTION_HEADER.SECOND_APPLICANT')})`;
};
